document.addEventListener('DOMContentLoaded', () => {
  const sliders = document.querySelectorAll('slider-component');

  sliders.forEach((slider, index) => {
    const scrollContainer = slider.querySelector('.slider') || slider.querySelector('.scroll-area');
    
    if (!scrollContainer) {
      console.warn(`No scroll container found for slider #${index}`);
      return;
    }

    // Get all slides within the container
    const slides = scrollContainer.children;
    if (!slides.length || scrollContainer.scrollWidth <= scrollContainer.clientWidth) {
      console.log(`Slider #${index} has no overflow to scroll or no slides.`);
      return;
    }

    console.log(`✅ Starting slide-by-slide auto-scroll on slider #${index}`);

    let currentSlideIndex = 0;
    let slideInterval;
    const slideDelay = 3000; // 2 seconds between slides
    
    function goToSlide(slideIndex) {
      if (slideIndex >= slides.length) {
        slideIndex = 0;
      }
      
      // Calculate position of the target slide
      const slidePosition = slides[slideIndex].offsetLeft;
      scrollContainer.scrollTo({
        left: slidePosition,
        behavior: 'smooth'
      });
      
      currentSlideIndex = slideIndex;
    }

    function nextSlide() {
      goToSlide(currentSlideIndex + 1);
      slideInterval = setTimeout(nextSlide, slideDelay);
    }

    // Start the slideshow
    slideInterval = setTimeout(nextSlide, slideDelay);

    scrollContainer.addEventListener('mouseenter', () => {
      clearTimeout(slideInterval);
      console.log(`🛑 Paused auto-scroll on slider #${index}`);
    });

    scrollContainer.addEventListener('mouseleave', () => {
      console.log(`▶️ Resumed auto-scroll on slider #${index}`);
      slideInterval = setTimeout(nextSlide, slideDelay);
    });
  });
});
